import { render, staticRenderFns } from "./AgencyWithdrawalInfo.vue?vue&type=template&id=94894d38&"
import script from "./AgencyWithdrawalInfo.vue?vue&type=script&lang=js&"
export * from "./AgencyWithdrawalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports